import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import { required } from '@/lib/rule';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  props: {
    email: null,
    password: null
  },
  emits: ["update:isValidForm", "update:email", "update:password", "submit"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValidForm', data: boolean): void;
  (e: 'update:email', data: string): void;
  (e: 'update:password', data: string): void;
  (e: 'submit'): void;
}), expose: any, slots: any, attrs: any }) {





const isValidForm = ref<boolean>(false);
const showPassword = ref(false);

const updateIsValidForm = (e: boolean) => {
  emits('update:isValidForm', e);
};

const updateEmail = (e: string) => {
  emits('update:email', e);
};

const updatePassword = (e: string) => {
  emits('update:password', e);
};

const submit = () => {
  emits('submit');
};

return { __sfc: true,emits, isValidForm, showPassword, updateIsValidForm, updateEmail, updatePassword, submit, required, sharedMessages }
}

})